import React, { useEffect, useState } from 'react';
import Loader from '../../components/Loader/Loader';
import MoreInfo from './MoreInfo/MoreInfo';
import './Promozioni.css';
import PromozioniBody from './PromozioniBody/PromozioniBody';
import Footer from '../components/FooterIT/FooterIT';
import Header from '../components/HeaderIT/HeaderIT';
import euLadyBackgr1 from '../../assets/eu-lady-background.png';
import euLadyBackgr2 from '../../assets/eu-lady-background2.png';
import zaraGiftCard from '../../assets/IT/zara-gift-card-it.png';
import eurospinGiftCard from '../../assets/IT/eurospin-it.png';
import carrefourGiftCard from '../../assets/IT/carrefour.png';
import coopGiftCard from '../../assets/IT/coop2.png';
import mdGiftCard from '../../assets/IT/md.png';
import GDPRCookieConsent from '../../components/CookieConsent/GDPRCookieConsent';
import { useTranslation } from '../../locales/useTranslation';

const Promozioni = ({ pageName }) => {
  const { t, translations } = useTranslation('it');
  const [title, setTitle] = useState('Vinci una Carta Regalo! Registrati per continuare!');
  const [headline, setHeadline] = useState('');
  const [subheadline, setSubheadline] = useState('');
  const [picURL, setpicURL] = useState('');
  const [loading, setLoading] = useState(false);
  const [backGr1, setBackgr1] = useState('none');
  const [backGr2, setBackgr2] = useState('none');
  const [textColorDesktop, setTextColorDesktop] = useState('rgb(44, 78, 146)');
  const [textColorMobile, setTextColorMobile] = useState('white');
  const [campaignName, setCampaignName] = useState('IT Zara 500€');

  useEffect(() => {
    // Zara 500€ offer
    if (pageName.includes('zara') && pageName.includes('500')) {
      setTitle('Vinci una Carta Regalo Zara!');
      setHeadline('Vesti Zara! Per te un buono 500€');
      setSubheadline('*Utilizzabile in Tutti gli store');
      setpicURL(zaraGiftCard);
      setBackgr1(euLadyBackgr1);
      setBackgr2(euLadyBackgr2);
      setCampaignName('IT Zara 500€');
    } 
    // Eurospin 1000€ offer
    else if (pageName.includes('eurospin') && pageName.includes('1000')) {
      setTitle('Carta Regalo Eurospin Giveaway!');
      setHeadline('Vinci 1000€ per la tua spesa da Eurospin!');
      setSubheadline('');
      setpicURL(eurospinGiftCard);
      setBackgr1(euLadyBackgr1);
      setBackgr2(euLadyBackgr2);
      setCampaignName('IT Eurospin 1000€');
    }
    // Carrefour 1000€ offer
    else if (pageName.includes('carrefour') && pageName.includes('1000')) {
      setTitle('Carta Regalo Carrefour Giveaway!');
      setHeadline('Vinci 1000€ per la tua spesa da Carrefour!');
      setSubheadline('');
      setpicURL(carrefourGiftCard);
      setBackgr1(euLadyBackgr1);
      setBackgr2(euLadyBackgr2);
      setCampaignName('IT Carrefour 1000€');
    }
    // Coop 1000€ offer
    else if (pageName.includes('coop') && pageName.includes('1000')) {
      setTitle('Carta Regalo Coop Giveaway!');
      setHeadline('Vinci 1000€ per la tua spesa da Coop!');
      setSubheadline('');
      setpicURL(coopGiftCard);
      setBackgr1(euLadyBackgr1);
      setBackgr2(euLadyBackgr2);
      setCampaignName('IT Coop 1000€');
    }
    // MD 1000€ offer
    else if (pageName.includes('md') && pageName.includes('1000')) {
      setTitle('Carta Regalo MD Giveaway!');
      setHeadline('Vinci 1000€ per la tua spesa da MD!');
      setSubheadline('');
      setpicURL(mdGiftCard);
      setBackgr1(euLadyBackgr1);
      setBackgr2(euLadyBackgr2);
      setCampaignName('IT MD 1000€');
    }
  }, [pageName]);

  return (
    <div>
      <Header />
      <div className="main-container">
        {loading ? (
          <div className="loader-div">
            <h2 id="loading-text">Verifica dell'idoneità...</h2>
            <br />
            <br />
            <Loader width="15.5em" height="12.23em" style={{ border: '1px solid black' }} />
          </div>
        ) : (
          <PromozioniBody
            title={title}
            headline={headline}
            subheadline={subheadline}
            picURL={picURL}
            backgroundPic1={backGr1}
            backgroundPic2={backGr2}
            textColorDesktop={textColorDesktop}
            textColorMobile={textColorMobile}
            campaignName={campaignName}
            translations={translations}
          />
        )}

        <MoreInfo translations={translations} />
      </div>
      <Footer translations={translations} />
      <GDPRCookieConsent locale="it" translations={translations} />
    </div>
  );
};

export default Promozioni;
